import React, { useEffect, useState, useRef } from "react";
import NavigationDrawer from "../../components/navigationDrawer/index";
import CustomBar from "../../components/customBar";
import AppContainer from "../../components/containers/AppContainer";
import TextInput from "../../components/textInput";
import { Button, Divider } from "@mui/material";
import { APP_ICONS } from "../../assets";
import SelectInput from "../../components/select";
import DynamicTable from "../../components/dynamicTable";
import CustomDialog from "./notificationAdd";
import AddIcon from "@mui/icons-material/Add";
import NotificationAdd from "./notificationAdd";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import {
  deleteNotification,
  getAllNotification,
} from "../../services/notification";
import AppLoader from "../../components/loader/loader";
import NotificationButtons from "./notificationButtons";

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const tableHeader = ["TITLE", "BODY", "ACTIONS"];

const displayRows = ["title", "body", "actions_btn"];

const Notifications = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    body: "",
    type: "",
  });
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const snackRef = useRef();
  const [selectedButton, setSelectedButton] = useState(null);

  useEffect(() => {
    const savedCategory = localStorage.getItem("selectedButton");
    if (savedCategory) {
      setSelectedButton(JSON.parse(savedCategory));
    } else {
      const defaultCategory = {
        id: 1,
        name: "Customer Notification",
        type: "hire",
      };
      setSelectedButton(defaultCategory);
    }
  }, []);

  useEffect(() => {
    if (selectedButton?.type) {
      fetchNotifications(selectedButton.type);
      localStorage.setItem("selectedButton", JSON.stringify(selectedButton));
    }
  }, [selectedButton]);

  const handleCategorySelect = (category) => {
    setSelectedButton(category);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = (shouldRefresh = false) => {
    setDialogOpen(false);
    setFormData({ title: "", body: "", type: selectedButton?.type });
    setEditData(null);
    if (shouldRefresh) {
      fetchNotifications(selectedButton?.type);
    }
  };

  const handleFormSubmit = (data) => {
    setTableData((prevData) => [...prevData, data]);
  };

  const handleOpenSnack = (status, message) => {
    if (snackRef.current) {
      snackRef.current.isOpenSnack({
        snackType: status,
        snackMessage: message,
      });
    }
  };

  const fetchNotifications = async (type) => {
    console.log(type, "typetypetype");

    setLoading(true);
    try {
      const response = await getAllNotification({
        appType: type || selectedButton?.type,
      });
      if (response.data.status === "success") {
        setTableData(response.data.data);
      } else {
        handleOpenSnack("error", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      handleOpenSnack(
        "error",
        "An error occurred while fetching notifications"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (row) => {
    setEditData(row);
    setFormData({
      title: row.title,
      body: row.body,
      type: row.appType || selectedButton?.type,
    });
    handleDialogOpen();
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await deleteNotification(id);
      if (response.data.status === "success") {
        snackRef.current?.isOpenSnack({
          snackType: "success",
          snackMessage: response.data.message,
        });
        fetchNotifications(selectedButton?.type);
      } else {
        snackRef.current?.isOpenSnack({
          snackType: "error",
          snackMessage: response.data.message,
        });
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
      snackRef.current?.showMessage("Failed to delete notification", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <AppLoader isVisible={loading} />
      <CustomBar title={"NOTIFICATIONS"} />
      <NotificationButtons
        onCategorySelect={handleCategorySelect}
        selectedButton={selectedButton?.id}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "right",
        }}
      >
        <NotificationAdd
          open={dialogOpen}
          onClose={handleDialogClose}
          onSubmit={handleFormSubmit}
          formData={formData}
          setFormData={setFormData}
          editData={editData}
          setEditData={setEditData}
          selectedButton={selectedButton}
          fetchNotifications={fetchNotifications}
          type={selectedButton?.type}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleDialogOpen}
          sx={{
            px: 0,
            py: 0.5,
            fontWeight: "medium",
            fontSize: "16px",
            fontFamily: "Poppins",
            textTransform: "none",
            position: "relative",
            overflow: "hidden",
            width: "120px",
            backgroundColor: "primary.main",
            color: "#fff",
            my: 2,
            borderRadius: "12px",
            border: "2px solid transparent",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
              backgroundColor: "primary.main",
              boxShadow: "0 12px 25px rgba(139, 69, 19, 0.6)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: "0",
              left: "0",
              background: "linear-gradient(45deg, #8B4513, #D2691E)",
              borderRadius: "inherit",
              transform: "scale(0)",
              transition: "transform 0.3s ease",
              zIndex: "-1",
            },
            "&:hover::before": {
              transform: "scale(1)",
            },
          }}
        >
          <AddIcon /> Add
        </Button>
      </div>
      <AppContainer>
        <Divider />
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={tableData}
          showPagination={true}
          showUserMenu={true}
          handleEdit={handleEdit}
          handleDelete={(row) => handleDelete(row._id)}
        />
      </AppContainer>{" "}
      <CustomSnackbar ref={snackRef} />
    </NavigationDrawer>
  );
};

export default Notifications;
